export const LANGUAGE_STORAGE_KEY = 'notesplus_language';

export const SUPPORTED_LANGUAGES = [
  { code: 'tr', short: 'TR', shortLabel: 'TR', flag: '🇹🇷', flagFile: 'tr.svg', label: 'Türkçe', nativeLabel: 'Türkçe' },
  { code: 'en', short: 'EN', shortLabel: 'EN', flag: '🇬🇧', flagFile: 'gb.svg', label: 'English', nativeLabel: 'English' },
  { code: 'fr', short: 'FR', shortLabel: 'FR', flag: '🇫🇷', flagFile: 'fr.svg', label: 'Français', nativeLabel: 'Français' },
  { code: 'ar', short: 'AR', shortLabel: 'AR', flag: '🇸🇦', flagFile: 'sa.svg', label: 'العربية', nativeLabel: 'العربية' },
  { code: 'id', short: 'ID', shortLabel: 'ID', flag: '🇮🇩', flagFile: 'id.svg', label: 'Bahasa Indonesia', nativeLabel: 'Bahasa Indonesia' },
];

export const SUPPORTED_LANGUAGE_CODES = SUPPORTED_LANGUAGES.map((lang) => lang.code);

export function normalizeLanguageCode(language) {
  return String(language || 'en').split('-')[0].toLowerCase();
}

export function getLanguageOption(language) {
  const code = normalizeLanguageCode(language);
  return SUPPORTED_LANGUAGES.find((lang) => lang.code === code) || SUPPORTED_LANGUAGES[1];
}

export function getPublicAssetUrl(relativePath) {
  const cleaned = String(relativePath || '').replace(/^\//, '');
  const rawBase = (typeof process !== 'undefined' && process.env && process.env.PUBLIC_URL)
    ? String(process.env.PUBLIC_URL)
    : '.';
  const base = rawBase.replace(/\/$/, '') || '.';
  return `${base}/${cleaned}`;
}

export function getFlagImageSrc(language) {
  const lang = getLanguageOption(language);
  return getPublicAssetUrl(`flags/${lang.flagFile}`);
}

export async function persistAppLanguage(code) {
  const normalized = normalizeLanguageCode(code);
  if (!SUPPORTED_LANGUAGE_CODES.includes(normalized)) return false;

  if (typeof window !== 'undefined' && window.api?.setLocale) {
    await window.api.setLocale(normalized);
    return true;
  }

  if (typeof localStorage !== 'undefined') {
    localStorage.setItem(LANGUAGE_STORAGE_KEY, normalized);
    return true;
  }

  return false;
}

export async function changeAppLanguage(i18nInstance, code) {
  const normalized = normalizeLanguageCode(code);
  if (!SUPPORTED_LANGUAGE_CODES.includes(normalized)) return false;
  await i18nInstance.changeLanguage(normalized);
  await persistAppLanguage(normalized);
  return true;
}
